import React, {Component} from 'react';
import {Field, formValueSelector, reduxForm} from 'redux-form';
import Tooltip from 'rc-tooltip';
import PropTypes from 'prop-types';
import HelpCircle from 'react-feather/dist/icons/help-circle.js';
import {connect} from 'react-redux';

import Date from '../../Form/Field/Date.jsx';
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx';
import Input from '../../Form/Field/Input.jsx';
import Loader from '../../../../shared/components/Loader/Loader.jsx';
import RemoveCdiModal from '../../Modals/RemoveCdiModal/RemoveCdiModal.jsx';
import Select from '../../Form/Field/Select.jsx';

import connectModal from '../../../../shared/components/Modals/connect.js';
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js';
import normBoolean from '../../Form/Normalizer/boolean.js';
import validate from './validate.js';

import api from '../../../../api.js';

export const name = 'AdminFreelanceMonitorForm';

class AdminFreelanceMonitorForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agents: [],
    };
  }

  static propTypes = {
    className: PropTypes.string,
    isReviewed: PropTypes.bool,
    hasSkillsFileUploaded: PropTypes.bool
  };

  static defaultProps = {
    className: '',
    isReviewed: false,
    hasSkillsFileUploaded: false
  };

  componentDidMount = async () => {
    if (null !== this.props.currentUniverseId) {
      const agents = (await api.users.getBusinessManagersByUniverse({
        universe: this.props.currentUniverseId
      })).data;
      this.setState({agents})
    }
  }

  handleCdiChange = (event, newValue) => {
    if (true === newValue) {
      this.triggerPublicChange(false);
    }
  };

  handlePublicChange = (event, newValue) => {
    if (true === newValue && this.props.cdiChecked) {
      this.props.openRemoveCdiModal({
        triggerCdiChange: this.triggerCdiChange,
        triggerPublicChange: this.triggerPublicChange
      });
    }
  };

  handleSeenChange = (event, newValue) => {
    if (newValue === true) {
      this.props.change('freelance.no_show', false);
    }
  };

  handleNoShowChange = (event, newValue) => {
    if (newValue === true) {
      this.props.change('freelance.seen', false);
    }
  };

  /**
   * @param {boolean} newValue
   */
  triggerPublicChange = (newValue= false) => {
    this.props.change('freelance.public', newValue);
  };

  /**
   * @param {boolean} newValue
   */
  triggerCdiChange = (newValue= false) => {
    this.props.change('freelance.cdi', newValue);
  };

  render() {
    const reviewedId = 'reviewed';
    const hasStoppedSms = 'has-stopped-sms';
    const skillsFileUploadedId = 'skills-file-uploaded';
    const checkedDcUploaded = (this.props.currentRegistrationStep && this.props.currentRegistrationStep === '7') ||
      this.props.hasSkillsFileUploaded

    return (
      <div id={name} className={this.props.className}>
        <form autoComplete="off" onSubmit={this.props.handleSubmit}>
          <div className="row">
            <div className="col-xl-6">
              <div
                className="d-flex flex-wrap justify-content-around bg-gray-50 bd-gray-200 flex-grow-1 my-1 pt-3 px-2">
                <Field
                  name="user.complete"
                  type="checkbox"
                  normalize={normBoolean}
                  component={Input}
                  label="Complet"
                />
                <Field
                  name="freelance.seen"
                  type="checkbox"
                  normalize={normBoolean}
                  component={Input}
                  label="Vu en rendez-vous"
                  onChange={this.handleSeenChange}
                />
                <Field
                  name="freelance.public"
                  type="checkbox"
                  normalize={normBoolean}
                  onChange={this.handlePublicChange}
                  component={Input}
                  label="Public"
                />
                <div className="form-group">
                  <input
                    id={reviewedId}
                    checked={this.props.isReviewed}
                    type="checkbox"
                    disabled={true}
                    aria-disabled={true}
                  />&nbsp;
                  <label htmlFor={reviewedId}>Noté</label>
                </div>
                <div className="form-group">
                  <input
                    id={skillsFileUploadedId}
                    checked={checkedDcUploaded}
                    type="checkbox"
                    disabled={true}
                    aria-disabled={true}
                  />&nbsp;
                  <label htmlFor={skillsFileUploadedId}>Dc Uploadé</label>
                </div>
              </div>
            </div>
            <div className="col-xl-6">
              <div
                className="d-flex flex-wrap justify-content-around bg-gray-50 bd-gray-200 flex-grow-1 my-1 pt-3 px-2">
                <Field
                  name="user.gold"
                  type="checkbox"
                  normalize={normBoolean}
                  component={Input}
                  label={<span>
                    Label Gold
                    <Tooltip
                      placement="top"
                      trigger={['hover', 'click', 'focus']}
                      overlay={
                        <span>
                          Lorsqu'un profil est "gold", une médaille apparait sur sa carte (uniquement pour les
                          utilisateurs ayant accès à ce volet), il remontera plus haut dans les recherche et il peut
                          être filtré dans la recherche
                        </span>
                      }
                    >
                      <HelpCircle size={20}/>
                    </Tooltip>
                  </span>}
                />
                <Field
                  name="freelance.twineeds_contract"
                  type="checkbox"
                  normalize={normBoolean}
                  component={Input}
                  label="Contrat Twineeds"
                />
                <Field
                  name="user.unreliable"
                  type="checkbox"
                  normalize={normBoolean}
                  component={Input}
                  label="Profil douteux"
                />
                <Field
                  name="freelance.no_show"
                  type="checkbox"
                  normalize={normBoolean}
                  component={Input}
                  label="No show"
                  onChange={this.handleNoShowChange}
                />
                <div className="form-group">
                  <input
                    id={hasStoppedSms}
                    checked={this.props.hasStoppedSms}
                    type="checkbox"
                    disabled={true}
                    aria-disabled={true}
                  />&nbsp;
                  <label htmlFor={hasStoppedSms}>Stop SMS</label>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-6">
              <div
                className="d-flex flex-wrap justify-content-around bg-gray-50 bd-gray-200 flex-grow-1 my-1 pt-3 px-2">
                <Field
                  label="Date de disponibilité"
                  name="freelance.date_available"
                  placeholder="JJ/MM/AAAA"
                  type="text"
                  component={Date}/>
                <Field
                  label="Date de relance"
                  name="freelance.date_next_action"
                  placeholder="JJ/MM/AAAA"
                  type="text"
                  component={Date}/>
              </div>
            </div>
            <div className="d-flex col-xl-6 align-items-stretch">
              <div
                className="d-flex flex-wrap align-items-center justify-content-around bg-gray-50 bd-gray-200 flex-grow-1 my-1 pt-3 px-2">
                <Field
                  name="freelance.cdi"
                  type="checkbox"
                  normalize={normBoolean}
                  component={Input}
                  onChange={this.handleCdiChange}
                  label={<span>
                    Profil en CDI
                    <Tooltip
                      placement="top"
                      trigger={['hover', 'click', 'focus']}
                      overlay={
                        <span>Le freelance a indiqué être en cdi, il n'est plus visible par les visiteurs du site</span>
                      }
                    >
                      <HelpCircle size={20}/>
                    </Tooltip>
                  </span>}/>
                {this.props.cdiChecked ?
                  <Field
                    label="Date de début de CDI"
                    name="freelance.date_cdi_start"
                    placeholder="JJ/MM/AAAA"
                    type="text"
                    component={Date}/> : ''
                }
              </div>
            </div>
          </div>
          <div className="row">
            <div className="d-flex col-xl-6 align-items-stretch">
              <div
                className="d-flex flex-wrap align-items-center justify-content-around bg-gray-50 bd-gray-200 flex-grow-1 my-1 pt-3 px-2">
                <div className={"form-group"}>
                  <label>
                    Agent du consultant
                  </label>
                </div>
                <Field
                  name="freelance.agent"
                  multiple={false}
                  component={Select}>
                  <option/>
                  {this.state.agents.map((agent) => (
                    <option value={agent.id} key={agent.id}>{agent.fullname}</option>
                  ))}
                </Field>
              </div>
            </div>
          </div>
          <input className="d-none" type="submit"/>
          <FormGlobalErrors className="mt-0" errors={this.props.error}/>
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit}/>
      </div>
    );
  }
}

const ReduxAdminFreelanceMonitorForm = reduxForm({
  form: name,
  validate,
  onSubmitFail: createOnSubmitFailHandler(name)
})(AdminFreelanceMonitorForm);

const selector = formValueSelector(name);

export default connectModal({RemoveCdiModal}, connect(
  state => ({
    cdiChecked: selector(state, 'freelance.cdi'),
    currentUniverseId: state?.universe?.currentUniverse?.id ?? null,
  })
)(ReduxAdminFreelanceMonitorForm));
